module.exports = __webpack_public_path__ + "static/img/no-internet.dc063dd9.svg";